import { useEffect } from 'react';
import axios from 'axios';
import { ensurePixel, META_PIXEL_DEFAULT_ID } from '../lib/metaPixel';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Runs once at App mount:
 *  - Reads /api/public/tracking to get the current Meta Pixel ID configured
 *    by the admin.
 *  - If it differs from the hardcoded default, re-inits fbq with the new ID
 *    (both will fire — that's fine while the admin migrates).
 *  - If tracking is `active: false`, we simply don't add extra IDs. The base
 *    pixel in index.html will still fire PageView once (acceptable).
 */
export const MetaPixelLoader = () => {
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API_URL}/api/public/tracking`, { withCredentials: false })
      .then(({ data }) => {
        if (cancelled || !data) return;
        if (data.active === false) return;
        const id = (data.meta_pixel_id || '').trim();
        if (!id) return;
        if (id !== META_PIXEL_DEFAULT_ID) {
          ensurePixel(id);
          // eslint-disable-next-line no-console
          console.info('[metaPixel] pixel override from admin:', id);
        }
      })
      .catch(() => {
        /* silent: tracking must never break the app */
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return null;
};
